module.exports = __webpack_public_path__ + "static/media/LOGO.4b3ecf89.png";